import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IBandhai, IBandhaiInitialState } from "./bandhaiModel";
import {
  createBandhai,
  deleteBandhai,
  deleteBandhaiApprovalItem,
  deleteBandhaiEntryItems,
  deleteBandhaiOrderItems,
  findAllBandhai,
  getBandhaiById,
  updateBandhai,
} from "./services/bandhai.services";

const initialState: IBandhaiInitialState = {
  loading: false,
  error: "",
  BandhaiID: null,
  BandhaiList: [],
  BandhaiDetail: {
    issue_date: new Date(),
    issue_no: null,
    approx_delivery_date: "",
    karigar_id: null,
    given_amount: null,
    remarks: "",
    bandhai_order: [],
    bandhai_Entry_item: [],
  },
  FilterBandhai: {
    karigar_name: "",
    karigar_nick_name: "",
    issue_date: "",
    approx_delivery_date: "",
  },
  BandhaiOrderItemIndex: -1,
  BandhaiEntryItemIndex: -1,
  BandhaiApprovalItemIndex: -1,
  BandhaiSelectOrderItemIndex: -1,
  BandhaiOrderSelectionDialog: false,
  BandhaiApprovalItemDeleteDialog: false,
  BandhaiViewImageDialog: false,
  BandhaiOrderSave: false,
  BandhaiPreviousOrder: null,
};

const bandhaiSlice = createSlice({
  name: "bandhai",
  initialState,
  reducers: {
    clearBandhaiDetail: (state) => {
      state.BandhaiDetail = initialState.BandhaiDetail;
    },
    setBandhaiID: (state, action) => {
      state.BandhaiID = action.payload;
    },
    setFilterBandhai: (state, action) => {
      state.FilterBandhai = action.payload;
    },
    setBandhaiOrderSave: (state, action) => {
      state.BandhaiOrderSave = action.payload;
    },
    clearFilterBandhai: (state) => {
      state.FilterBandhai = initialState.FilterBandhai;
    },

    setBandhaiOrderItemIndex: (state, action) => {
      state.BandhaiOrderItemIndex = action.payload;
    },
    setBandhaiSelectOrderItemIndex: (state, action) => {
      state.BandhaiSelectOrderItemIndex = action.payload;
    },
    setBandhaiEntryItemIndex: (state, action) => {
      state.BandhaiEntryItemIndex = action.payload;
    },
    setBandhaiApprovalItemIndex: (state, action) => {
      state.BandhaiApprovalItemIndex = action.payload;
    },
    setBandhaiPreviousOrder: (state, action) => {
      state.BandhaiPreviousOrder = action.payload;
    },

    openBandhaiOrderSelectionDialog: (state) => {
      state.BandhaiOrderSelectionDialog = true;
    },
    closeBandhaiOrderSelectionDialog: (state) => {
      state.BandhaiOrderSelectionDialog = false;
    },
    openBandhaiApprovalItemDeleteDialog: (state) => {
      state.BandhaiApprovalItemDeleteDialog = true;
    },
    closeBandhaiApprovalItemDeleteDialog: (state) => {
      state.BandhaiApprovalItemDeleteDialog = false;
    },
    openBandhaiViewImageDialog: (state) => {
      state.BandhaiViewImageDialog = true;
    },
    closeBandhaiViewImageDialog: (state) => {
      state.BandhaiViewImageDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllBandhai.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllBandhai.fulfilled,
      (state, action: PayloadAction<IBandhai[]>) => {
        state.loading = false;
        state.BandhaiList = action.payload || [];
      }
    );
    builder.addCase(findAllBandhai.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BandhaiList = [];
    });

    builder.addCase(createBandhai.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createBandhai.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createBandhai.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateBandhai.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateBandhai.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateBandhai.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteBandhai.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBandhai.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBandhai.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getBandhaiById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getBandhaiById.fulfilled, (state, action: any) => {
      state.loading = false;
      state.BandhaiDetail = action.payload;
    });
    builder.addCase(getBandhaiById.rejected, (state, action) => {
      state.loading = false;
      state.BandhaiDetail = initialState.BandhaiDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteBandhaiOrderItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBandhaiOrderItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBandhaiOrderItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteBandhaiApprovalItem.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBandhaiApprovalItem.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBandhaiApprovalItem.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteBandhaiEntryItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBandhaiEntryItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBandhaiEntryItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearFilterBandhai,
  clearBandhaiDetail,
  closeBandhaiApprovalItemDeleteDialog,
  closeBandhaiOrderSelectionDialog,
  closeBandhaiViewImageDialog,
  openBandhaiApprovalItemDeleteDialog,
  openBandhaiOrderSelectionDialog,
  openBandhaiViewImageDialog,
  setFilterBandhai,
  setBandhaiApprovalItemIndex,
  setBandhaiEntryItemIndex,
  setBandhaiID,
  setBandhaiOrderItemIndex,
  setBandhaiSelectOrderItemIndex,
  setBandhaiOrderSave,
  setBandhaiPreviousOrder,
} = bandhaiSlice.actions;
export default bandhaiSlice.reducer;
